module.exports = __webpack_public_path__ + "static/img/淘宝星河.0ca22ac4.png";